var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrubber",staticClass:"scrubber",class:( _obj = {dark: _vm.isDark}, _obj[_vm.size] = _vm.size, _obj ),style:(_vm.scrubberStyles)},[_c('Waveform')],1)
var _obj;}
var staticRenderFns = []

export { render, staticRenderFns }